import { createTheme } from "@fluentui/react";

export const defaultTheme = createTheme({
    palette: {
      themePrimary: "#D92525",
      themeLighterAlt: "#fdf5f5",
      themeLighter: "#f9d8d8",
      themeLight: "#f4b7b7",
      themeTertiary: "#e87474",
      themeSecondary: "#dd3c3c",
      themeDarkAlt: "#80b339",
      themeDark: "#a51c1c",
      themeDarker: "#791515",
      neutralLighterAlt: "#ececec",
      neutralLighter: "#e8e8e8",
      neutralLight: "#dedede",
      neutralQuaternaryAlt: "#cfcfcf",
      neutralQuaternary: "#d0d0d0",
      neutralTertiaryAlt: "#bebebe",
      neutralTertiary: "#9799be",
      neutralSecondary: "#7b7da9",
      neutralSecondaryAlt: "#8a8886",
      neutralPrimaryAlt: "#616494",
      neutralPrimary: "#191B40",
      neutralDark: "#373a6a",
      black: "#272955",
      white: "#F2F2F2",
    }
  });